import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const OrderSuccess = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { transactionId, reference } = location.state || {};

  return (
    <section className="order-success py-80">
      <div className="container container-lg">
        <div className="py-40 text-center">
          <div className="mb-24">
            <i className="text-main-500 ph-bold ph-check-circle" style={{ fontSize: '64px' }}></i>
          </div>
          <h3 className="mb-16">{t('order_success.title')}</h3>
          <p className="mb-16 text-gray-500">{t('order_success.message')}</p>
          
          {reference && (
            <p className="mb-32">
              <span className="fw-semibold">{t('order_success.reference')}:</span> {reference}
            </p>
          )}
          
          <div className="gap-3 d-flex justify-content-center">
            <Link to="/" className="px-32 btn btn-outline-main py-18 rounded-8">
              {t('order_success.back_to_home')}
            </Link>
            <Link to="/shop" className="px-32 btn btn-main py-18 rounded-8">
              {t('order_success.continue_shopping')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderSuccess; 